import React, { useState, useEffect } from 'react';
import { Table, Select, Button, message, Card, Typography, Space, Popconfirm, Row, Col } from 'antd';
import { SafetyOutlined, RocketOutlined, DeleteOutlined, BoxPlotOutlined } from '@ant-design/icons';
import axios from 'axios';

const { Title, Text } = Typography;

const RegistrationCenter = () => {
  const [data, setData] = useState({ unregistered: [], free_vpns: [] });
  const [loading, setLoading] = useState(true);
  const [selectedVpns, setSelectedVpns] = useState({});

  const fetchRegistrationData = async () => {
    try {
      const res = await axios.get('/api/box/registration-data/');
      // Sortiranje VPN fajlova numerički (box_1, box_2, box_10...)
      const sortedVpns = res.data.free_vpns.sort((a, b) => 
        a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' })
      );
      setData({ ...res.data, free_vpns: sortedVpns });
      setLoading(false);
    } catch (err) {
      console.error("Greška pri učitavanju:", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRegistrationData();
    const interval = setInterval(fetchRegistrationData, 10000); // Automatsko osvežavanje
    return () => clearInterval(interval);
  }, []);

  const handleRegister = async (unregId) => {
    const vpnFile = selectedVpns[unregId];
    if (!vpnFile) {
      message.warning("Moraš prvo izabrati slobodan VPN fajl!");
      return;
    }
    try {
      await axios.post('/api/box/register-confirm/', { unreg_id: unregId, vpn_file: vpnFile });
      message.success(`Box ${vpnFile.replace('.conf', '')} uspešno registrovan!`);
      fetchRegistrationData();
    } catch (err) {
      message.error("Greška prilikom registracije");
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/api/box/unregistered-delete/${id}/`);
      message.success("Uređaj uklonjen.");
      fetchRegistrationData();
    } catch (err) {
      message.error("Greška pri brisanju");
    }
  };

  const columns = [
    {
      title: 'Temporary ID',
      dataIndex: 'temp_id',
      key: 'temp_id',
      render: (text) => (
        <Space>
          <SafetyOutlined style={{ color: '#fbbf24' }} />
          <Text strong style={{ color: 'white' }}>{text}</Text>
        </Space>
      ),
    },
    {
      title: 'IP Address',
      dataIndex: 'ip',
      key: 'ip',
      render: (ip) => <span style={{ color: '#94a3b8' }}>{ip}</span>, // Čist tekst bez okvira
    },
    {
      title: 'Assign VPN / Box Name',
      key: 'assign',
      render: (_, record) => (
        <Select
          placeholder="Select free VPN config"
          style={{ width: 220 }}
          className="white-select"
          dropdownClassName="white-dropdown"
          onChange={(value) => setSelectedVpns({ ...selectedVpns, [record.id]: value })}
        >
          {data.free_vpns.map(file => (
            <Select.Option key={file} value={file}>
              {file.replace('.conf', '')}
            </Select.Option>
          ))}
        </Select>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Button 
            size="small" 
            icon={<RocketOutlined />} 
            style={{ background: '#1e293b', color: '#34d399', border: '1px solid #334155' }}
            onClick={() => handleRegister(record.id)}
          >
            Register
          </Button>

          <Popconfirm
            title="Obriši uređaj?"
            onConfirm={() => handleDelete(record.id)}
            okText="Da"
            cancelText="Ne"
          >
            <Button 
              size="small"
              icon={<DeleteOutlined />} 
              style={{ background: '#1e293b', color: '#ef4444', border: '1px solid #334155' }}
            >
              Delete
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: '0px' }}>
      <Row style={{ marginBottom: '24px' }}>
        <Col span={24}>
          <div style={{ background: '#1e293b', padding: '20px', borderRadius: '8px', border: '1px solid #334155' }}>
            <Space size="middle">
              <BoxPlotOutlined style={{ color: '#fbbf24', fontSize: '24px' }} />
              <div>
                <div style={{ color: '#64748b', fontSize: '12px' }}>PENDING REGISTRATION</div>
                <div style={{ color: 'white', fontSize: '24px', fontWeight: 'bold' }}>{data.unregistered.length}</div>
              </div>
            </Space>
          </div>
        </Col>
      </Row>

      <div style={{ 
        background: 'rgba(30, 41, 59, 0.3)', 
        padding: '24px', 
        borderRadius: '12px', 
        border: '1px solid #1e293b' 
      }}>
        <Table 
          dataSource={data.unregistered} 
          columns={columns} 
          loading={loading}
          rowKey="id"
          pagination={false}
          style={{ background: 'transparent' }}
          className="custom-table"
        />
      </div>

      <style>{`
        .custom-table .ant-table { background: transparent !important; color: #94a3b8 !important; }
        .custom-table .ant-table-thead > tr > th { 
          background: transparent !important; 
          color: #64748b !important; 
          border-bottom: 1px solid #1e293b !important; 
          text-transform: uppercase;
          font-size: 11px;
        }
        .custom-table .ant-table-tbody > tr > td { border-bottom: 1px solid #1e293b !important; }
        .custom-table .ant-table-tbody > tr:hover > td { background: rgba(255,255,255,0.02) !important; }
        
        .white-select .ant-select-selector { 
          background-color: white !important; 
          color: black !important; 
          border-radius: 4px !important;
        }
        .white-dropdown { background-color: white !important; }
        .white-dropdown .ant-select-item { color: black !important; }
        .white-dropdown .ant-select-item-option-active { background-color: #f0f0f0 !important; }
      `}</style>
    </div>
  );
};

export default RegistrationCenter;